import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {environment} from "@numizmat/environments";
import {
  AdRenewableResponse,
  AdRenewalResponse,
  DeleteAdResponse,
  DeleteGroupAdsRequest,
  InsertAdResponse,
  RenewalAdsRequest,
  StopAdResponse,
  StopGroupAdsRequest,
  UpdateAdResponse
} from "@numizmat/services-models/core";

@Injectable({
  providedIn: 'root'
})
export class AdApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private adController: string = 'ad';

  public insertAd(request: FormData): Observable<InsertAdResponse> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}`;
    return this.httpClient.post<InsertAdResponse>(endpoint, request);
  }

  public updateAd(adId: string, request: FormData): Observable<UpdateAdResponse> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/${adId}`;
    return this.httpClient.put<UpdateAdResponse>(endpoint, request);
  }

  public deleteAd(adId: string): Observable<DeleteAdResponse> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/${adId}`;
    return this.httpClient.delete<DeleteAdResponse>(endpoint);
  }

  public deleteGroupAds(request: DeleteGroupAdsRequest): Observable<number> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/group/delete`;
    return this.httpClient.post<number>(endpoint, request);
  }

  public getAllRenewableAds(): Observable<AdRenewableResponse[]> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/renewable/all`;
    return this.httpClient.get<AdRenewableResponse[]>(endpoint);
  }

  public stopAd(adId: string): Observable<StopAdResponse> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/stop/${adId}`;
    return this.httpClient.put<StopAdResponse>(endpoint, null);
  }

  public stopGroupAds(request: StopGroupAdsRequest): Observable<number> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/group/stop`;
    return this.httpClient.post<number>(endpoint, request);
  }

  public getAllAdRenewals(adId: string): Observable<AdRenewalResponse[]> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/renewal/all/${adId}`;
    return this.httpClient.get<AdRenewalResponse[]>(endpoint);
  }

  public renewalAdsAfterSold(request: RenewalAdsRequest): Observable<string[]> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/renewal/after-sold`;
    return this.httpClient.patch<string[]>(endpoint, request);
  }

  public renewalAdsAfterExpired(request: RenewalAdsRequest): Observable<number> {
    const endpoint: string = `${environment.apiCoreUrl}/${this.adController}/renewal/after-expired`;
    return this.httpClient.patch<number>(endpoint, request);
  }
}
